import './style.scss';

import { useEffect, useState } from 'react';
import * as React from 'react';
import { Flex, Loader, Text } from '@gjensidige/builders-components';

import { PriceBannerProps } from './Types';

export const PriceBanner: React.FC<PriceBannerProps> = (
  props: PriceBannerProps
) => {
  let stickyClassName = '';
  const element = document.querySelector('body');
  const getTopPosition = () =>
    element?.style.marginTop ? parseInt(element?.style.marginTop) - 2 : -2;
  //-2px is to avoid space issue in 1080 resolution screens

  const headTag = () =>
    window.document.querySelectorAll('*[class^="sticky-head"]')[0];
  const headHeight = () => (headTag() ? headTag().clientHeight : 0);
  const initialTopPosition = headHeight()
    ? getTopPosition() + headHeight() + 'px'
    : getTopPosition() + 'px';
  const [top, setTop] = useState(initialTopPosition);
  const setNewTopPosition = () => {
    const newTopPosition = headHeight()
      ? getTopPosition() + headHeight() + 'px'
      : getTopPosition() + 'px';
    setTop(newTopPosition);
  };
  useEffect(() => {
    window.onresize = setNewTopPosition;
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          setNewTopPosition();
        }
      });
    });
    const config = { attributes: true };
    element && observer.observe(element, config);
    return () => observer.disconnect();
  }, []);

  const wrapperClassName = `${
    props.wrapperClassName ? props.wrapperClassName : ''
  } `;
  if (props.shouldStickToTop) {
    stickyClassName = 'stick-to-top';
  }

  return (
    <div
      className={`total-price-card-wrapper ${wrapperClassName} ${stickyClassName}`}
      style={{ top: top }}
    >
      <div className="total-price-section">
        {props.centerTitle ? (
          <Flex center="md" layout="1">
            <Text size="body" weight="700" className="center-title">
              {props.centerTitle}
            </Text>
          </Flex>
        ) : (
          <Flex center="md" layout="1">
            <Flex
              justify="space-between"
              className="price-banner-wrapper"
              gap={{ xs: 'none', sm: 'sm', md: 'md', lg: 'xl' }}
            >
              <div className="total-price-container">
                <Text size="body" className="selected-package-label">
                  {props.packageSelected}
                </Text>
              </div>
              <div className="total-price-container total-price-justify">
                <>
                  {props.isUpdateInProgress ? (
                    <Loader variant="ellipsis" size="sm" />
                  ) : (
                    <Text size="body" className="selected-package-label">
                      {props.totalPriceWithCurrency}
                      <span className="payment-frequency-label">
                        {props.paymentFrequency}
                      </span>
                    </Text>
                  )}
                </>
              </div>
            </Flex>
          </Flex>
        )}
      </div>
    </div>
  );
};
